<template>
  <teleport to="#app">
    <transition name="modal-transition">
      <div class="modal-mask" :class="maskClass" v-if="show" @click="$emit('close')">
        <div class="modal-wrapper" :class="wrapperClass">
          <div class="modal-container" :class="[this.class, containerClass]" @click.stop>
            <div v-if="isLoading" class="modal-loader">
              <div class="spinner"></div>
            </div>
            <button
              v-if="!hideCloseButton"
              class="modal-close"
              @click="$emit('close')"
            ></button>
            <div class="modal-header" v-if="header">{{ header }}</div>
            <div class="modal-descr" v-html="description" v-if="description"></div>
            <slot name="content"></slot>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: "BaseModal",
  emits: ["close"],
  props: {
    class: String,
    containerClass: String,
    maskClass: String,
    wrapperClass: String,
    hideCloseButton: {
      type: Boolean,
      default: false
    },
    isLoading: Boolean,
    header: String,
    description: String,
    show: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(event) {
      if (event.key === 'Escape' && this.show) {
        this.$emit('close');
      }
    }
  }
};
</script>
